"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.button.login': 'Sign In Now',
    'activate.button.back_login': 'Back to Login',
    'activate.button.register_again': 'Register Again',
};
